import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { isNativeApp, openExternalUrl } from '../utils/platform';

/**
 * A component that performs a full browser redirect to a specified URL.
 *
 * @param props - The component props.
 * @param props.url - The external URL to navigate to.
 * @returns null
 */
export const RedirectExternal = ({ url }: { url: string }): null => {
  const navigate = useNavigate();

  useEffect(() => {
    if (isNativeApp()) {
      void openExternalUrl(url).finally(() => {
        navigate('/', { replace: true });
      });
      return;
    }

    // Force a full page reload to navigate to the external URL.
    void openExternalUrl(url, { replace: true });
  }, [navigate, url]);

  return null;
};
